<template>
  <div class="coupon-expire">
    <van-list
      v-model="loading"
      :finished="finished"
      finished-text="暂无更多数据"
      @load="onLoad"
    >
      <div
        class="coupon-item"
        :code="item.classify"
        v-for="item in couponList"
        :key="item.id"
      >
        <div class="coupon-info">
          <div class="coupon-amount">
            <div class="coupon-amount-info">
              <span>¥</span>
              <span>{{ item.amount.slice(1) }}</span>
            </div>
            <div class="use-desc">
              <h1>{{ item.enableAmount }}</h1>
              <span class="tag">{{
                item.classify | couponClassifyMaps
              }}</span>
            </div>
          </div>
          <div class="type-use">
            <div class="type-name">{{ item.classify | couponTypeMaps }}</div>
            <!-- <div class="use-btn">去使用</div> -->
          </div>
        </div>
        <div class="coupon-time" :code="item.classify">
          {{ item.expiresTime }}
        </div>

        <img class="flag-pic" src="@/assets/images/bg_coupon_tag_out.png" alt="">
      </div>
    </van-list>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { requestMethods } from "@m/api";
export default {
  data() {
    return {
      couponList: [],
      loading: false,
      finished: false,
      currentPage: 1,
      totalCount: 0,
    };
  },
  props: {
    currentIndex: {
        type: String,
        default: ""
    }
  },
  computed: {
    ...mapGetters(["userInfo", "uuid"]),
  },
  filters: {
    couponTypeMaps(val) {
      if (val == "COMMON") {
        return "通用券";
      }
      if (val == "UNIVERSAL") {
        return "万能券";
      }
      if (val == "CONTINUE_CHARGE") {
        return "续充券";
      }
      if (val == "FIRST_CHARGE") {
        return "首充券";
      }
    },
    couponClassifyMaps(val) {
      
      if (val == "COMMON") {
        return "全类别通用";
      }
      if (val == "UNIVERSAL") {
        return "全平台可用";
      }
      if (val == "CONTINUE_CHARGE") {
        return "仅限续充使用";
      }
      if (val == "FIRST_CHARGE") {
        return "仅限首充使用";
      }
    },
  },
  methods: {
    async onLoad() {
      await this.couponListQr();

      // 加载状态结束
      this.loading = false;

      // 数据全部加载完成
      if (this.couponList.length >= this.totalCount) {
        this.finished = true;
      } else {
        this.currentPage++;
      }
    },
    async couponListQr() {
      try {
        const { data, totalCount } = await requestMethods(
          "/modules/coupon/userCoupon/getUserCouponList.htm",
          "post",
          {
            uuid: this.uuid,
            status: this.currentIndex,
            currentPage: this.currentPage,
            pageSize: 10,
          }
        );
        this.couponList.push(...data);
        this.totalCount = totalCount
      } catch (err) {
        // 通过 err.message 获取到错误信息
        console.log(err.message);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.coupon-expire {
  .coupon-item {
    width: 710px;
    height: 200px;
    padding: 32px 32px 30px 32px;
    margin-bottom: 20px;
    position: relative;

    &[code="COMMON"] {
      background: url("~@/assets/images/bg_coupon_one_grey_used.png");
      background-size: 100% 100%;
    }
    &[code="FIRST_CHARGE"] {
      background: url("~@/assets/images/bg_coupon_two_grey_used.png");
      background-size: 100% 100%;
    }
    &[code="CONTINUE_CHARGE"] {
      background: url("~@/assets/images/bg_coupon_three_grey_used.png");
      background-size: 100% 100%;
    }
    &[code="UNIVERSAL"] {
      background: url("~@/assets/images/bg_coupon_four_grey_used.png");
      background-size: 100% 100%;
    }

    .flag-pic {
        position: absolute;
        width: 210px;
        height: 124px;
        right: 160px;
        top: 38px;
    }

    .coupon-info {
      display: flex;
      justify-content: space-between;
      align-items: flex-end;

      .coupon-amount {
        display: flex;
        align-items: flex-start;

        .coupon-amount-info {
          display: flex;
          align-items: flex-start;
          margin-right: 40px;

          span {
            font-family: PingFangSC, PingFang SC;
            font-weight: 600;
            font-size: 50px;
            color: #ffffff;
            line-height: 50px;

            &:last-child {
              font-family: PingFangSC, PingFang SC;
              font-weight: 600;
              font-size: 110px;
              color: #ffffff;
              line-height: 90px;
            }
          }
        }
        .use-desc {
          h1 {
            font-family: PingFangSC, PingFang SC;
            font-weight: 600;
            font-size: 40px;
            color: #ffffff;
            line-height: 56px;
          }
          span {
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            font-size: 24px;
            color: #ffffff;
            line-height: 33px;
            display: block;
            opacity: 0.5;
          }
        }
      }
      .type-use {
        text-align: center;
      }
      .type-name {
        font-family: PingFangSC, PingFang SC;
        font-weight: 600;
        font-size: 30px;
        color: #ffffff;
        width: 170px;
      }
    }
    .coupon-time {
      width: 307px;
      height: 31px;
      background: url("~@/assets/images/time-bg.png");
      background-size: 100% 100%;
      line-height: 31px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 600;
      font-size: 22px;
      color: #BBBBBB;
      margin-left: -32px;
      padding-left: 31px;
      margin-top: 12px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/coupon/components/Expire.vue